export default __webpack_public_path__ + "static/media/teamguna.6c5b99e1.mp4";